// Single source of truth for the Prof Lionel Person identity, used by every
// page/schema that needs to reference the author (BlogPost, ProfLionel page,
// AulaGratis, etc.). Reference: https://schema.org/Person
//
// Uses the canonical "Professor Lionel" name everywhere — previous code had
// three inconsistent variants ("Prof Lionel", "Prof. Lionel", "Lionel Philippe")
// which weaken the Knowledge Graph entity resolution for Google + AI Overview.

export const AUTHOR = {
  name: "Professor Lionel",
  alternateName: ["Prof Lionel", "Prof. Lionel", "M. Bonjour-merci"],
  jobTitle: "Professor de francês nativo de Paris",
  description:
    "Professor francês nativo de Paris com 20 anos ensinando francês para brasileiros — do A1 ao C2, preparação DELF/DALF/TEF/TCF, conversação e viagem.",
  image:
    "https://customer-assets.emergentagent.com/job_french-for-all-1/artifacts/fqb0z62o_Ame%CC%81lioration%20de%20la%20qualite%CC%81%20photo.png",
  url: "https://npdlbr.com.br/prof-lionel",
  nationality: "French",
  birthPlace: "Paris, France",
  worksFor: "Na Ponta Da Língua Brasil",
  knowsLanguage: ["French", "Portuguese", "English"],
  knowsAbout: [
    "French language teaching",
    "CEFR levels A1 A2 B1 B2 C1 C2",
    "DELF",
    "DALF",
    "TEF",
    "TCF",
    "French pronunciation",
    "Parisian French",
    "French culture",
    "French grammar",
    "FLE (Français Langue Étrangère)",
  ],
  credentials: [
    "Nativo de Paris (Île-de-France)",
    "20 anos ensinando francês no Brasil",
    "Especialista em preparação DELF, DALF, TEF e TCF",
    "Método sob medida para falantes de português brasileiro",
  ],
  sameAs: [
    "https://www.instagram.com/francescomlionel",
    "https://solteseufrances.com.br",
  ],
};

// Emits a full Person JSON-LD object ready to stringify. Kept centralised so
// every consumer benefits from the same E-E-A-T signals (nationality, alumniOf,
// knowsAbout, sameAs, hasCredential).
export function personSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": `${AUTHOR.url}#person`,
    name: AUTHOR.name,
    alternateName: AUTHOR.alternateName,
    jobTitle: AUTHOR.jobTitle,
    description: AUTHOR.description,
    image: AUTHOR.image,
    url: AUTHOR.url,
    nationality: AUTHOR.nationality,
    birthPlace: {
      "@type": "Place",
      name: AUTHOR.birthPlace,
      address: {
        "@type": "PostalAddress",
        addressLocality: "Paris",
        addressCountry: "FR",
      },
    },
    knowsLanguage: AUTHOR.knowsLanguage,
    knowsAbout: AUTHOR.knowsAbout,
    hasCredential: AUTHOR.credentials.map((c) => ({
      "@type": "EducationalOccupationalCredential",
      name: c,
    })),
    worksFor: {
      "@type": "EducationalOrganization",
      name: AUTHOR.worksFor,
      url: "https://npdlbr.com.br",
    },
    sameAs: AUTHOR.sameAs,
  };
}

// Compact Person object for embedding as `author` inside BlogPosting etc.
// Kept minimal on purpose — Google will resolve the full entity via @id.
export function personRef() {
  return {
    "@type": "Person",
    "@id": `${AUTHOR.url}#person`,
    name: AUTHOR.name,
    url: AUTHOR.url,
    image: AUTHOR.image,
    jobTitle: AUTHOR.jobTitle,
    sameAs: AUTHOR.sameAs,
  };
}
